import axios, { AxiosError, AxiosResponse } from "axios";
import { simpleAlert } from "../components/Alerts";

const DOMAIN = "https://server.finovaapp.com";

export const handleErrorRequestSquematic = (errors: string | any): string => {
  if (typeof errors === "string") return errors;

  const errs: string[] = [];

  Object.keys(errors).forEach((key) => {
    const value = errors[key as keyof object];
    if (Array.isArray(value)) {
      errs.push(...value);
    } else if (typeof value === "string") {
      errs.push(value);
    } else if (value === false) {
      errs.push("Error desconocido");
    }
  });

  return errs.join("\n\n");
};

export const getCurrentLanguage = () => {
  return navigator.language || "en";
};

export interface Session {
  correo: string;
  nombre: string;
  apellido: string;
  saldo: number;
  token: string;
}

export const getSession = (): Session | null => {
  try {
    const raw = localStorage.getItem("session");
    if (!raw) return null;

    const session = JSON.parse(raw);

    if (
      session &&
      typeof session.correo === "string" &&
      session.correo.trim() !== "" &&
      typeof session.nombre === "string" &&
      session.nombre.trim() !== "" &&
      typeof session.token === "string" &&
      session.token.trim() !== ""
    ) {
      return {
        correo: session.correo,
        nombre: session.nombre,
        apellido: typeof session.apellido === "string" ? session.apellido : "",
        saldo: Number(session.saldo) || 0,
        token: session.token,
      };
    }

    return null;
  } catch {
    return null;
  }
};

export const updateSessionSaldo = (nuevoSaldo: number | string) => {
  const session = getSession();
  if (!session) return;
  setSession({ ...session, saldo: Number(nuevoSaldo) || 0 });
};

export const setSession = (session: Session) => {
  localStorage.setItem("session", JSON.stringify(session));
};

export const clearSession = () => {
  localStorage.removeItem("session");
};

export const requestSquematic = async (
  type: "GET" | "POST" | "DELETE" | "PUT",
  url: string,
  object: any,
  token?: string,
  onTokenError?: () => void,
): Promise<any> => {
  try {
    let res: AxiosResponse<any>;
    let headers: any = token ? { Authorization: `Bearer ${token}` } : {};
    //const auth = token ? { headers: { Authorization: `Bearer ${token}` } } : undefined;

    const isFormData = object instanceof FormData;

    if (isFormData) {
      headers["Content-Type"] = "multipart/form-data"; // Detectar si es FormData y lo agrega
    }

    if (type === "GET") {
      res = await axios.get(DOMAIN + url, { headers, params: object });
    } else {
      res = await axios.post(DOMAIN + url, object, { headers });
    }

    const data = res.data;

    if (data.status === "OK") {
      return data;
    } else {
      console.log("error primero", DOMAIN + url, object, token, data.errors!);
      //let error = data.errors!;
      let errorText = handleErrorRequestSquematic(data.errors);
      let errorFooter =
        "Error en la peticion: " +
        url.split("/")[url.split("/").length - 2] +
        "/" +
        url.split("/")[url.split("/").length - 1];
      //Se agrega esto para que el cliente no vea lo que exactamente envia el servidor
      /* if (
        data.errors &&
        ![
          "verificate_id",
          "send_otp_email",
          "send_otp_sms",
          "login",
          "validate_otp",
        ].includes(url.split("/")[url.split("/").length - 1])
      ) {
        error =
          "Error en la peticion: " +
          url.split("/")[url.split("/").length - 2] +
          "/" +
          url.split("/")[url.split("/").length - 1];
      } */
      simpleAlert("Error: " + errorText, errorFooter, "Ok", () => {});
    }
  } catch (error) {
    console.log("error segundo", DOMAIN + url, object, token, error);

    if (axios.isAxiosError(error)) {
      const err: AxiosError = error;

      if (err.response?.status === 401) {
        onTokenError?.();
        simpleAlert(
          "Sesión caducada...",
          "Tu sesión ha caducado, vuelve a iniciar",
          "Ok",
          () => {},
        );
      } else {
        let messageTemp = (error as any).toString().includes("Network")
          ? "Error en la conexión"
          : error;
        simpleAlert(
          "Error en el envio",
          "Error en el servidor: " + messageTemp,
          "Ok",
          () => {},
        );
      }
    } else if (error instanceof TypeError) {
      simpleAlert("Error Type", "Error en tipado: " + error, "OK", () => {});
    } else {
      simpleAlert("Error Last", "Server problem: " + error, "Ok", () => {});
    }
  }
};

export const handleError = (titleError: string = "Error", error: any) => {
  const errorMessage = error instanceof Error ? error.message : String(error);
  simpleAlert(titleError, errorMessage, "Ok", () => {});
};
